"use client";

// مرز code-split سمت client: dynamic() فقط داخل کامپوننت client چانک جدا می‌سازد
// (از Server Component همه‌ی کد client صفحه‌ها در یک چانک مشترک می‌آمد).
import dynamic from "next/dynamic";

// بدون loading fallback تا DOM دوبار ساخته نشود.
// خود صفحه‌ی کلاینتی (_component) مستقیم روی سرور رندر می‌شود. قبلاً indexMapping در HTML سرور یک نسخه‌ی
// اسکلتی (_component.ssr) می‌فرستاد و بعد از hydrate کل صفحه را با _component عوض می‌کرد: قیمت، واریانت و
// دکمه‌ی خرید در HTML نبود و همه‌چیز بعد از اجرای JS دوباره ساخته می‌شد.
export default dynamic(() => import("./_component"));
